import { render, staticRenderFns } from "./PublisherSetupTabExcluded.vue?vue&type=template&id=f7e5e446"
import script from "./PublisherSetupTabExcluded.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTabExcluded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports